<template>
  <div class="withdraw-page">
    <nav-header module="提现"></nav-header>
    <div class="container">
      <div class="title-module">
        <h2 class="title">
          <i class="icon"></i>
          提现余额
        </h2>
        <div class="fr" v-if="!accountBalance.Commission">
          <span class="label">余额：</span>
          <span class="count"><i class="unit">￥</i>{{accountBalance.BalanceAmount | formatPrice}}</span>
        </div>
        <div class="fr" v-if="accountBalance.Commission">
          <el-radio v-model="type" :label="1" @input="clickBalance">
            <span class="label">余额：</span>
            <span class="count"><i class="unit">￥</i>{{accountBalance.BalanceAmount | formatPrice}}</span>
          </el-radio>
          <el-radio v-model="type" :label="2" @input="clickCommission">
            <span class="label">佣金：</span>
            <span class="count"><i class="unit">￥</i>{{accountBalance.Commission | formatPrice}}</span>
          </el-radio>
        </div>
      </div>
      <div class="form">
        <div class="form-item">
          <span class="label">提现方式：</span>
          <div class="input-box">
            <label class="radiobox" v-for="(item,index) in accountList" :key="index">
              <input class="radio" type="radio" name="type" :value="item" v-model="pickedAccount" >
              <div class="radio-block">
                <span :class="['icon-tag', {'tag-cx':item.AccountProperty==1,'tag-xy':item.AccountProperty==2,}]"></span>
                <span class="name">{{item.BankName}}</span>
                <span class="number">{{item.DisplayAccount}}</span>
              </div>
              <span class="default" v-if="item.IsDefault">默认</span>
              <span class="default" v-if="!item.IsDefault"  @click.prevent="setDefault(item)">设为默认</span>
              <span class="btn-remove" @click.prevent="removeAccount(item)">删除</span>
            </label>
            <div class="btn-add" @click="isShowAdd=true">
              <i class="el-icon-plus"></i>
              <span class="text">新增账户</span>
            </div>
          </div>
        </div>
        <div class="form-item" v-show="userInfo.LoginAccountType==1">
          <span class="label">提现金额：</span>
          <input type="text" class="input" v-model.number="count" :disabled="isCommend" style="margin-top: 6px;">
          <span class="unit">元</span>
          <span class="tel">客服电话：021-60956592</span>
        </div>
      </div>
      <button class="btn-primary" @click="nextStep">{{userInfo.LoginAccountType==1?'下一步':'提现'}}</button>
      <div class="tips">
        <div class="tips-title">温馨提示：</div>
        <p>
          1、提现金额输入值必须是不小于10且不大于50000的正整数；如有问题，请咨询客服；<br>2、提现完成后，您可以进入账户提现记录页面进行查看余额提现状态。
        </p>
      </div>
    </div>
    <add-account-dialog :isShow="isShowAdd" @close="isShowAdd=false" @success="onSuccess"></add-account-dialog>
  </div>
</template>
<script>
import navHeader from '@/components/navHeader.vue'
import addAccountDialog from '@/components/addAccountDialog.vue'
import {
  GetMyCollectionAccount,
  SetDefaultCollectionAccount,
  DeleteCollectionAccount,
  SubmitPersonWithDrawApply,
  WithdrawWait,

  isSignRlwyContract,
  usercheck,
} from '@/scripts/api.js'
import validate from '@/scripts/validate.js'
import {mapState} from 'vuex'
export default {
  components:{
    navHeader,
    addAccountDialog,
  },
  data(){
    return{
      accountList:[],
      isShowAdd:false,
      pickedAccount:null,
      count:'',
      type:1,//1余额，2佣金

      isCommend: false,
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
      accountBalance:state=>state.accountBalance,
    }),
  },
  // watch:{
  //   $route(to){
  //     if(to.path=='/withdraw'){
  //       this.$store.dispatch('loadAccountBalance');
  //     }
  //   }
  // },
  created() {
    this.pageInit();
  },
  mounted() {
    this.$store.dispatch('loadAccountBalance');
    this.$store.dispatch('loadAccountData');//重新获取企业的余额
  },
  methods: {
    pageInit(){
      //获取收款账号列表
      GetMyCollectionAccount({
        userCode:this.userInfo.UserCode,
        ShowTypes: 2
        // ShowTypes:this.userInfo.LoginAccountType==2?[2]:[1,2]
      }).then(r=>{
        if(r.Result==1){
          this.accountList=r.Data ||[];
        }
      })
    },
    //删除账号
    removeAccount(item){
      let params={
        id:item.ID,
        userCode:this.userInfo.UserCode,
      }
      this.$confirm('确定删除吗？').then(() => {
        DeleteCollectionAccount(params).then(r=>{
          if(r.Result==1){
            this.pageInit();
          }
          this.$toast(r.Message);
        })
      });
    },
    //设置默认
    setDefault(item){
      let params={
        id:item.ID,
        userCode:this.userInfo.UserCode,
      }
      SetDefaultCollectionAccount(params).then(r=>{
        if(r.Result==1){
          this.pageInit();
        }
        this.$toast(r.Message);
      })
    },
    //添加账号回调
    onSuccess(){
      this.isShowAdd=false;
      this.pageInit();
    },

    // 点击余额
    clickBalance(){
      this.isCommend = !this.isCommend
      this.count = ''
    },
    // 个人佣金
    clickCommission(){
      this.isCommend = !this.isCommend
      this.count = this.accountBalance.Commission
    },




    //提现
    nextStep(){
      let that=this;
      if(that.userInfo && !that.userInfo.RealNameStatus &&that.userInfo.LoginAccountType==1) {
        this.$toast('暂未实名，请移步APP完成实名后提现');
        return;
      }
      // RealNameStatus
      if(!this.pickedAccount){
        this.$toast('请选择提现账号');
        return;
      }
      if(that.userInfo.LoginAccountType==2){
        this.companyWithdraw();
      }else{
        if(!this.count) {
          this.$toast('请输入提现金额');
          return
        }
        // if(!validate.positiveInt(this.count)){
        //   this.$toast('请输入正整数');
        //   return;
        // }
        // if(this.count<10 || this.count>50000){
        //   this.$toast('提现金额输入值必须是不小于10且不大于50000的正整数');
        //   return;
        // }
        if(this.accountBalance.Commission && this.type == 2) {
          let data = {
            nuserId: this.userInfo.LoginAccountId,
            nuserType: 1
          }
          isSignRlwyContract(data).then(res=> {
            if(res.Result != 1) {
              return this.$toast('请移步APP完成提现');
            }
            if(res.Data) {
              let params = {}
              params.idNumber = this.userInfo.CardID
              params.phoneNumber = this.userInfo.Handset
              usercheck(params).then(r=> {
                if(!r.success) {
                  return this.$toast('请移步APP完成提现');
                }
                // 审核状态码 0:未提交 20:待工商审核 -20:工商已驳回 25:待复审 27:出照中 30:已出照
                let state = r.result.state
                if(state == 0 || state == -20 || state == 25) {
                  this.$confirm('您的个体工商户注册失败/已驳回，请重新提交认证。',{
                    confirmButtonText: '去APP操作',
                    cancelButtonText: '仍要提现',
                  }).then(() => {
                    console.log('去APP操作')
                  }).catch(()=>{
                    this.$password({
                      async onConfirm (data){
                        await that.personWithdraw(data);
                        this.close();
                      },
                      onCancel(){
                        this.close();
                        that.$router.push('/center/accountProtect');
                      }
                    })
                  });
                }else if(state == 20 || state == 27) {
                  this.$alert('您的个体工商户注册待审核中/待复核中，请稍后查询认证。', {
                    confirmButtonText: '我知道了',
                  });
                }else if(state == 1) {
                  this.$alert('您账号绑定的手机号或者身份证号码与工商认证的信息不匹配。', {
                    confirmButtonText: '我知道了',
                  });
                }else{
                  this.$password({
                    async onConfirm (data){
                      await that.personWithdraw(data);
                      this.close();
                    },
                    onCancel(){
                      this.close();
                      that.$router.push('/center/accountProtect');
                    }
                  })
                }
              })
            }else {
              this.$password({
                async onConfirm (data){
                  await that.personWithdraw(data);
                  this.close();
                },
                onCancel(){
                  this.close();
                  that.$router.push('/center/accountProtect');
                }
              })
            }
          })
        }else{
          this.$password({
            async onConfirm (data){
              await that.personWithdraw(data);
              this.close();
            },
            onCancel(){
              this.close();
              that.$router.push('/center/accountProtect');
            }
          })
        }
      }
      
    },
    //个人提现
    personWithdraw(password){
      let params={
        UserId:this.userInfo.LoginAccountId,
        WidthDrawAmount:this.count,
        WithDrawChannel:this.type,
        PayPassword:password,
        CollectionAccountId:this.pickedAccount.ID,
      }
      SubmitPersonWithDrawApply(params).then(r=>{
        if(r.Result==1){
          this.type = 1
          this.isCommend = false
          this.$router.push('/afterWithdraw');
        }else{
          this.$toast(r.Message);
        }
      })
    },
    //企业提现
    companyWithdraw(){
      let params={
        applyAccountID:this.pickedAccount.ID,
        applyMpValue:this.userInfo.MpValue,
        UserCode:this.userInfo.UserCode
      }
      WithdrawWait(params).then(r=>{
        if(r.Result==1){
          this.type = 1
          this.isCommend = false
          this.$router.push('/afterWithdraw');
        }else{
          this.$toast(r.Message);
        }
      })
    }
  },
}
</script>
<style lang="scss">
.withdraw-page{
  .header-main {
    width: 1000px;
  }
  .container{
    width: 1000px;
    margin: 0 auto;
    background-color: #fff;
    padding-top: 70px;
    overflow: hidden;
  }
  .title-module{
    margin-top: 40px;
    margin-bottom: 50px;
    height: 50px;
    overflow: hidden;
    border-bottom: 1px solid #e5e5e5;
    .title{
      font-size: 16px;
      font-weight: bold;
      line-height: 50px;
      color: #333;
      float: left;
    }
    .icon{
      display: inline-block;
      vertical-align: middle;
      width: 28px;
      height: 30px;
      background: url('~@/assets/balance/sp-logo.png') no-repeat center;
      margin-right: 5px;
      margin-top: -3px;
    }
    .fr{
      float: right;
    }
    .label{
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
    .count{
      font-size: 22px;
      color: #f75959;
      font-weight: bold;
      font-family: 'DIN-Regular';
      line-height: 50px;
      .unit{
        font-size: 14px;
      }
    }
  }
  .form{
    .form-item{
      margin-bottom: 20px;
      overflow: hidden;
    }
    .label{
      float: left;
      font-size: 16px;
      color: #666;
      line-height: 40px;
      font-weight: bold;
      width: 150px;
      text-align: right;
      padding-right: 20px;
    }
    .input{
      float: left;
      width: 100px;
      height: 30px;
      padding-left: 12px;
      padding-right: 12px;
      color: #333;
      font-size: 14px;
      font-weight: bold;
      line-height: 28px;
      border: 1px solid #ccc;
      margin-top: 10px;
      &:focus{
        border-color: #f75959;
      }
    }
    .unit{
      float: left;
      font-size: 14px;
      color: #999;
      line-height: 30px;
      margin-top: 10px;
      margin-left: 10px;
    }
    .tel{
      float: left;
      font-size: 14px;
      color: #f75959;
      line-height: 30px;
      margin-top: 10px;
      margin-left: 10px;
    }
    .input-box{
      float: left;
      width: 600px;
    }
    .radiobox{
      position: relative;
      overflow: hidden;
      margin-bottom: 10px;
      width: 600px;
      height: 50px;
      display: block;
      .radio{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        font-size: 600px;
        opacity: 0;
      }
      .radio-block{
        border: 1px solid #e5e5e5;
        height: 50px;
        line-height: 50px;
        padding-left: 60px;
        &:before{
          content: "";
          position: absolute;
          left: 20px;
          top: 50%;
          margin-top: -7px;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border: 1px solid #ccc;
          background-color: #fff;
          padding: 2px;
          box-sizing: border-box;
        }
      }
      .radio:checked+.radio-block{
        border-color: #f75959;
        &:before{
          background-color: #f75959;
          border-color: #f75959;
          background-clip: content-box;
        }
      }
      .icon-tag{
        width: 56px;
        height: 48px;
        background-repeat: no-repeat;
        background-position: center;
        display: inline-block;
        vertical-align: middle;
        background-size: contain;
        margin-right: 20px;
        margin-top: -3px;
        &.tag-xy{
          background-image: url('~@/assets/balance/tag-xy.png');
        }
        &.tag-cx{
          background-image: url('~@/assets/balance/tag-cx.png');
        }
      }
      .name{
        font-size: 14px;
        color: #333;
        font-weight: bold;
        display: inline-block;
        width: 130px;
      }
      .number{
        font-size: 14px;
        color: #999;
        display: inline-block;
        width: 180px;
      }
      .default{
        font-size: 14px;
        color: #999;
        display: inline-block;
        position: absolute;
        right: 80px;
        top: 0;
        z-index: 5;
        line-height: 50px;
        cursor: pointer;
      }
      .btn-remove{
        font-size: 14px;
        color: #f75959;
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 0;
        z-index: 5;
        display: none;
        line-height: 50px;
      }
      &:hover{
        .btn-remove{
          display: block;
        }
      }
    }
  }
  .btn-add{
    width: 600px;
    border: 1px solid #e5e5e5;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    cursor: pointer;
    &:hover{
      border-color: #f75959;
    }
    .el-icon-plus{
      font-size: 18px;
      color: #ccc;
      margin-right: 10px;
    }
    .text{
      font-size: 14px;
      color: #333;
      font-weight: bold;
    }
  }
  .btn-primary{
    width: 180px;
    height: 44px;
    margin-left: 150px;
    display: block;
    margin-top: 50px;
    font-size: 16px;
    cursor: pointer;
  }
  .tips{
    margin-left: 150px;
    margin-top: 30px;
    .tips-title{
      font-size: 14px;
      color: #333;
      line-height: 24px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p{
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
  }
}
</style>